module.exports = __webpack_public_path__ + "img/ico-payments.20a24a20.svg";